import { createContext, useContext } from 'react';

export const AccessContext = createContext(null);
export const PROFILE_LABELS = {
  super_admin: 'Super Admin',
  tenant_admin: 'Admin do Tenant',
  campaign_user: 'Criação de campanhas',
  viewer: 'Consulta e exportação',
};
export function useAccess() {
  const user = useContext(AccessContext);
  return {
    user,
    can: (key) =>
      (user?.permissions ?? []).some(
        (p) => p === '*' || p === key || (p.endsWith('.*') && key.startsWith(p.slice(0, -1))),
      ),
  };
}
